import { useNavigation } from '@/contexts/NavigationContext';
import { Plus } from 'lucide-react';

export const TabNav = () => {
  const { navigateToTab, navigateToPersonal, setActiveConversationId, setActiveAgentId } = useNavigation();

  const handleNewConversation = () => {
    navigateToPersonal();
    navigateToTab('chat');
    setActiveConversationId(null);
    setActiveAgentId(null);
  };

  return (
    <div className="flex items-center gap-1.5">
      <button
        onClick={handleNewConversation}
        className="px-1.5 lg:px-3 py-1.5 rounded-md text-xs font-medium border transition-all border-color text-secondary hover:bg-hover flex items-center gap-1.5"
        title="Nova Conversa"
      >
        <Plus className="w-3.5 h-3.5 flex-shrink-0" />
        <span className="hidden lg:inline">Nova Conversa</span>
      </button>
    </div>
  );
};
